export default "__VITE_ASSET__DcH2m9iS__"